import React, { createContext, useCallback, useState } from "react";
import { clientFetch } from "../utils/clientFetch";

type NameCollationsResponseType = {
  collation_value: string
  measure_name: string
}

export const NameCollationsContext = createContext<{
  nameCollations: NameCollationsResponseType[]
}>({
  nameCollations: []
})

export const UpdateNameCollationsContext = createContext<{
  refreshNameCollations: () => void
}>({
  refreshNameCollations: async () => { }
})

export function useNameCollationsContext() {
  const [nameCollations, setNameCollations] = useState([])

  const refreshNameCollations = useCallback(async () => {
    try {

      const res = await clientFetch(`${process.env.REACT_APP_API_ENDPOINT}/apis/admin/name-collations`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await res.json();
      setNameCollations(data);
    } catch (error) {
      console.error("Error fetching name collations.");
    }
  }, [])

  return {
    nameCollations,
    refreshNameCollations
  }
}

export function NameCollationsProvider({ children }: { children: React.ReactNode }) {
  const { nameCollations, refreshNameCollations } = useNameCollationsContext()

  return (
    <UpdateNameCollationsContext.Provider value={{ refreshNameCollations }}>
      <NameCollationsContext.Provider value={{ nameCollations }}>
        {children}
      </NameCollationsContext.Provider>
    </UpdateNameCollationsContext.Provider>
  )
}
